import { FunctionalComponent, createContext, h } from 'preact';
import { StateUpdater, useContext, useState } from 'preact/hooks';
import { TCFData } from '@usercentrics/cmp-browser-sdk';

export interface TCFState {
  setTcfData: StateUpdater<TCFData | null>;
  tcfData: TCFData | null;
}

const initialValues = {
  tcfData: null,
  /* eslint-disable-next-line */
  setTcfData: () => {},
};

const TcfContext = createContext<TCFState>(initialValues);

export const TcfContextProvider: FunctionalComponent = ({ children }) => {
  const [tcfData, setTcfData] = useState<TCFData | null>(initialValues.tcfData);

  return <TcfContext.Provider value={{ setTcfData, tcfData }}>{children}</TcfContext.Provider>;
};

export const useTcfContext = (): TCFState => {
  return useContext(TcfContext);
};
